<template>
  <b-modal
    id="add-bank-modal"
    centered
    title="Add Bank Account"
    @hide="resetData"
    ref="add_bank_modal"
  >
    <div class="modal-wrap">
      <b-form @submit="submit" @input="formInput">
        <label for="bankcode">Select Bank</label>
        <b-form-select
          id="bankcode"
          v-model="form.bankcode"
          @input="fetchAccountName"
          :disabled="fetchingName"
          :options="nigerianBanks"
          :state="fieldState.bankcode"
          required
        >
          <template v-slot:first>
            <option :value="null" disabled>-- Select Your Bank --</option>
          </template>
        </b-form-select>
        <b-form-invalid-feedback :state="fieldState.bankcode">{{ formErrors.bankcode }}</b-form-invalid-feedback>
        <b-form-group
          :invalid-feedback="formErrors.accountnumber"
          :state="fieldState.accountnumber"
        >
          <b-form-input
            id="accountnumber"
            class="mt-4"
            v-model="form.accountnumber"
            :state="fieldState.accountnumber"
            @input="fetchAccountName"
            :disabled="fetchingName"
            type="tel"
            required
            trim
            placeholder="Enter Account Number"
          ></b-form-input>
          <p v-if="fetchingName">
            <b-spinner small></b-spinner>Fetching name...
          </p>
          <b-form-invalid-feedback :state="!wrongAcct">That's a wrong NUBAN account number</b-form-invalid-feedback>
        </b-form-group>
        <b-form-input class="mt-4" :value="accountName || 'Account name'" disabled trim></b-form-input>
        <div class="text-center mt-1">
          <StatefulButton
            :loading="requestingOTP"
            loadingText="Requesting..."
            text="Click to request OTP"
            variant="primary"
            @click="requestOTP"
            elementType="button"
            elementClass="w-100 my-3"
            v-if="!sentOTP"
          />
          <p
            class="text-center text-success my-3 bg-light p-3 d-inline-block mx-auto"
            v-else
          >OTP has been sent to {{ userObj.email }}</p>
        </div>
        <b-form-group :invalid-feedback="formErrors.otp" :state="fieldState.otp">
          <b-form-input
            id="otp"
            v-model="form.otp"
            :state="fieldState.otp"
            :disabled="fetchingName"
            type="tel"
            required
            trim
            placeholder="OTP"
          ></b-form-input>
        </b-form-group>
      </b-form>
    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="light" @click="cancel()">Cancel</b-button>
      <StatefulButton
        :error="error || accountName == ''"
        :loading="submitting"
        loadingText="Adding..."
        text="Add"
        variant="primary"
        @click="submit"
      />
    </template>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import StatefulButton from "@/components/actions/StatefulButton";

import nigerianBanks from "@/utils/nigerianBanks";
import { BankAccountService, UserService } from "@/services";
import {
  validateDigits,
  validateRequired,
  checkFormErrors
} from "@/utils/validators";

export default {
  name: "add-bank",
  data() {
    return {
      form: {
        bankcode: "",
        accountnumber: "",
        otp: ""
      },
      sentOTP: false,
      accountName: "",
      formErrors: {},
      error: false,
      submitting: false,
      wrongAcct: false,
      fetchingName: false,
      searchTimeout: null,
      nigerianBanks: nigerianBanks,
      requestingOTP: false
    };
  },
  components: {
    StatefulButton
  },
  computed: {
    ...mapState(["userObj"]),
    fieldState() {
      return checkFormErrors(this.formErrors);
    }
  },
  methods: {
    async requestOTP() {
      this.requestingOTP = true;
      try {
        await UserService.requestOTP("addbank");
        this.sentOTP = true;
        this.requestingOTP = false;
      } catch (err) {
        this.requestingOTP = false;
      }
    },
    async fetchAccountName() {
      this.wrongAcct = false;
      this.accountName = "";
      const { bankcode, accountnumber } = this.form;
      if (!bankcode || !accountnumber) return;
      if (accountnumber.length !== 10) return;

      this.fetchingName = true;
      clearTimeout(this.searchTimeout);
      const self = this;
      self.searchTimeout = setTimeout(async () => {
        try {
          const { account_name } = await BankAccountService.resolve(
            accountnumber,
            bankcode
          );
          self.accountName = account_name;
          this.fetchingName = false;
        } catch (error) {
          this.wrongAcct = true;
        } finally {
          this.fetchingName = false;
        }
      }, 500);
    },

    async submit(event) {
      event.preventDefault();
      this.submitting = true;
      try {
        this.validateForm();
        await BankAccountService.add(this.form);
        this.$store.dispatch("toast", {
          message: "Bank account has been successfully added"
        });
        this.$refs.add_bank_modal.hide();
        setTimeout(() => {
          location.reload();
        }, 1000 * 1.5);
      } catch (err) {
        this.formErrors = err;
        this.error = true;
        this.submitting = false;
      }
    },
    validateForm() {
      const { accountnumber, otp } = this.form;
      let { errors, valid } = validateRequired(this.form);
      if (!errors.accountnumber) {
        const res = validateDigits(accountnumber, "accountnumber");
        errors.accountnumber = res.errors.accountnumber;
        valid = valid && res.valid;
      }
      if (!errors.accountnumber && accountnumber.length != 10) {
        errors.accountnumber = "Account number length must be 10";
        valid = false;
      }
      if (!errors.otp) {
        const res = validateDigits(otp, "otp");
        errors.otp = res.errors.otp;
        valid = valid && res.valid;
      }
      if (valid === false) throw errors;
    },
    formInput(event) {
      event.preventDefault();
      this.error = false;
      this.formErrors = {};
    },
    resetData() {
      Object.assign(this.$data, this.$options.data.apply(this));
    }
  }
};
</script>

<style lang="scss" scoped></style>
